import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatRadioChange } from '@angular/material/radio';
//import { ModuleName } from '../../services/task.enum';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-task-attach-ccc',
  templateUrl: './task-attach-ccc.component.html',
  styleUrls: ['./task-attach-ccc.component.scss']
})
export class TaskAttachCccComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  OfficeIDList: any = [];
  myOfficeID: any;

  timeout = null;  
  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrSendlValue: any;
  stateCtrlValue:string;
  objectList:any=[];

  @Output() closeAssignedTask = new EventEmitter<boolean>();
  @Input() taskId : number;
  @Input() fromList : boolean = false;
  
  showTaskUpdateButton:boolean=false;
  taskDetailList:any=[]=[];

  menuModulesList:any=[]=[];
  CoreShowName:string="";
  ContactShowName:string="";
  CompanyShowName:string="";

  entityTypeAttached:number=1;
  taskAttachedEntity:any=[]=[];
  getTaskAttachedEntityInDetails:any=[]=[];
  spinner:boolean=false;

  constructor(private loaderService: LoaderService,private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private router: Router,private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,  
    private statusConst: StatusConstant,private settingsService: SettingService,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  states= this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

   ngOnInit(): void {  
  }

  ngOnChanges(changes: SimpleChanges) {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore=[];
    var SelectedContact=[];
    var SelectedCompany=[];

    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if(SelectedCore.length>0){
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
      if(SelectedContact.length>0){
        this.ContactShowName = SelectedContact[0].orgModuleName;
     }

    SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
      if(SelectedCompany.length>0){
        this.CompanyShowName = SelectedCompany[0].orgModuleName;
      }
  
    this.taskId; 
    if(this.taskId>0){   
     this.getTaskDetailByID();
    }    
  }  


  getTaskDetailByID() {
    this.showTaskUpdateButton=false;
    this.loaderService.show();
    var ReqModel={
       taskID:this.taskId,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList
    }      
    this.settingsService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;        
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskDetailList = response.data;
         
          this.entityTypeAttached = this.taskDetailList.entityTypeAttached;

          // Check for Attched To          
          this.getTaskAttachedEntityInDetails  = this.taskDetailList.taskAttachedEntity;

         
          if(this.getTaskAttachedEntityInDetails.length>0){

             // Core-1,Contact-2,Company-3

             // Added For Core
             if(this.entityTypeAttached==1){
              
              this.ShowAttchedToCore=true;
              this.ShowAttchedToContact=false;
              this.ShowAttchedToCompany=false;
          
              this.checkedAttachCore=true;
              this.checkedAttachContact=false;
              this.checkedAttachCompany=false;

              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i){
                var shortName="";
                shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');          
                var ReqModelAttachCore={
                  taskAttachedEntityID:this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                  coreID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                  email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                  name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                  title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                  img:  this.getTaskAttachedEntityInDetails[i].imageUrl,
                  typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                  isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                  shortName:shortName
                 }
                 this.attachedToSelectedCore.push(ReqModelAttachCore);   
                }
             }

             // Added For Contact
             if(this.entityTypeAttached==2){
              
              this.ShowAttchedToCore=false;
              this.ShowAttchedToContact=true;
              this.ShowAttchedToCompany=false;
          
              this.checkedAttachCore=false;
              this.checkedAttachContact=true;
              this.checkedAttachCompany=false;

              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i){
                var shortName="";
                shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');              
                if(this.getTaskAttachedEntityInDetails[i].imageUrl==null){
                  this.getTaskAttachedEntityInDetails[i].imageUrl="";
                 }
                var ReqModelAttachContact={
                  taskAttachedEntityID:this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                  contactID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                  email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                  name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                  title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                  img:  this.getTaskAttachedEntityInDetails[i].imageUrl==null ?? "",
                  typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                  isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                  shortName:shortName
                 }
                 this.attachedToSelectedContact.push(ReqModelAttachContact);   
                }
             }

              // Added For Company
              if(this.entityTypeAttached==3){
              
                this.ShowAttchedToCore=false;
                this.ShowAttchedToContact=false;
                this.ShowAttchedToCompany=true;
            
                this.checkedAttachCore=false;
                this.checkedAttachContact=false;
                this.checkedAttachCompany=true;
  
                for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i){
                  var shortName="";
                  shortName = this.getTaskAttachedEntityInDetails[i].attachedEntityName.match(/\b(\w)/g).join('');           
                  if(this.getTaskAttachedEntityInDetails[i].imageUrl==null){
                    this.getTaskAttachedEntityInDetails[i].imageUrl="";
                   }
                  var ReqModelAttachCompany={
                    taskAttachedEntityID:this.getTaskAttachedEntityInDetails[i].taskAttachedEntityID,
                    companyID: this.getTaskAttachedEntityInDetails[i].attachedEntityID,
                    email: this.getTaskAttachedEntityInDetails[i].attachedEntityEmail,
                    name: this.getTaskAttachedEntityInDetails[i].attachedEntityName,
                    title: this.getTaskAttachedEntityInDetails[i].attachedEntityTitle,
                  //  transactionID:  this.getTaskAttachedEntityInDetails[i].transactionID,
                    img:  this.getTaskAttachedEntityInDetails[i].imageUrl,
                    typeID: this.getTaskAttachedEntityInDetails[i].attachedEntityTypeID,
                    isDeleted: this.getTaskAttachedEntityInDetails[i].isDeleted,
                    shortName:shortName
                   }
                   this.attachedToSelectedCompany.push(ReqModelAttachCompany);   
                  }
               }
          }else{
            this.ShowAttchedToCore=true;
            this.ShowAttchedToContact=false;
            this.ShowAttchedToCompany=false;
        
            this.checkedAttachCore=true;
            this.checkedAttachContact=false;
            this.checkedAttachCompany=false;

            this.entityTypeAttached=1;
          }

          this.loaderService.hide();
        }
        else {
          this.taskDetailList=[];
          this.loaderService.hide();
        }
      }
      else {
        this.taskDetailList=[];
        this.loaderService.hide();
      }
    });
  }



   //==============Update SubTask Details ===================//

   
   async updateTaskDetail(){
 
     //=====Check select Assigned To ===//
     // Contact-1,Role-2,Email-3,User-4
    
     this.taskAttachedEntity=[];
     
      
    // =========== For Attched To ===============//
       // For Core=1,Contact=2,Company=3
 
     // For Core 
     if(this.entityTypeAttached==1){
       if(this.attachedToSelectedCore.length>0){
        for (var i = 0, len = this.attachedToSelectedCore.length; i < len; ++i){
         var taskAttachedEntityID=this.attachedToSelectedCore[i].taskAttachedEntityID;
         var isDeleted=this.attachedToSelectedCore[i].isDeleted;
         if(taskAttachedEntityID==0 && isDeleted==true){
 
        }else{
         // var shortName="";
         // shortName = this.attachedToSelectedCore[i].name.match(/\b(\w)/g).join('');
          var coreAttached={
            taskAttachedEntityID: this.attachedToSelectedCore[i].taskAttachedEntityID,
            taskID: this.taskId,
            attachedEntityID: this.attachedToSelectedCore[i].coreID,
            attachedEntityRelation:"",
            attachedEntityTitle: this.attachedToSelectedCore[i].title,
            attachedEntityName: this.attachedToSelectedCore[i].name,
            attachedEntityEmail: this.attachedToSelectedCore[i].email,
            attachedEntityTypeID: this.attachedToSelectedCore[i].typeID,
            isDeleted: this.attachedToSelectedCore[i].isDeleted,
          //  shortName:shortName,
           // img:this.attachedToSelectedCore[i].imageUrl,
          }
          this.taskAttachedEntity.push(coreAttached);
        }
       }
       }
      }
 
      // For Contact 
     if(this.entityTypeAttached==2){
       if(this.attachedToSelectedContact.length>0){
        for (var i = 0, len = this.attachedToSelectedContact.length; i < len; ++i){
         var taskAttachedEntityID = this.attachedToSelectedContact[i].taskAttachedEntityID;
         var isDeleted = this.attachedToSelectedContact[i].isDeleted;
         if(taskAttachedEntityID==0 && isDeleted==true){
 
        }else{
         // var shortName="";
         // shortName = this.attachedToSelectedContact[i].name.match(/\b(\w)/g).join('');
          var contactAttached={
            taskAttachedEntityID: this.attachedToSelectedContact[i].taskAttachedEntityID,
            taskID: this.taskId,
            attachedEntityID: this.attachedToSelectedContact[i].contactID,
            attachedEntityRelation:"",
            attachedEntityTitle: this.attachedToSelectedContact[i].title,
            attachedEntityName: this.attachedToSelectedContact[i].name,
            attachedEntityEmail: this.attachedToSelectedContact[i].email,
            attachedEntityTypeID: this.attachedToSelectedContact[i].typeID,
            isDeleted: this.attachedToSelectedContact[i].isDeleted,
           // shortName:shortName,
           // img:this.attachedToSelectedContact[i].imageUrl,
          }
          this.taskAttachedEntity.push(contactAttached);
         }
        }
       }
     }
 
      // For Company 
     if(this.entityTypeAttached==3){
       if(this.attachedToSelectedCompany.length>0){
        for (var i = 0, len = this.attachedToSelectedCompany.length; i < len; ++i){        
          var taskAttachedEntityID=this.attachedToSelectedCompany[i].taskAttachedEntityID;
          var isDeleted=this.attachedToSelectedCompany[i].isDeleted;
          if(taskAttachedEntityID==0 && isDeleted==true){
 
         }else{
         // var shortName="";
         // shortName = this.attachedToSelectedCompany[i].name.match(/\b(\w)/g).join('');
           var companyAttached={
             taskAttachedEntityID: this.attachedToSelectedCompany[i].taskAttachedEntityID,
             taskID: this.taskId,
             attachedEntityID: this.attachedToSelectedCompany[i].companyID,
             attachedEntityRelation:"",
             attachedEntityTitle: this.attachedToSelectedCompany[i].title,
             attachedEntityName: this.attachedToSelectedCompany[i].name,
             attachedEntityEmail: this.attachedToSelectedCompany[i].email,
             attachedEntityTypeID: this.attachedToSelectedCompany[i].typeID,
             isDeleted: this.attachedToSelectedCompany[i].isDeleted,
            // shortName:shortName,
            // img:this.attachedToSelectedCompany[i].imageUrl,
           }
           this.taskAttachedEntity.push(companyAttached);
         }       
        }   
       }
      }
 
     var ReqModel={
       isAddOnlyAssinee: false,
       isAttacheOnly: true,
       taskID: Number(this.taskId),

       entityTypeAttached: this.entityTypeAttached,
      
       taskAttachedEntity: this.taskAttachedEntity,
 
       organizationID: Number(this.organizationId),
       databaseID: Number(this.databaseId),
       createdBy: this.currentUser.UID,
       officeID: this.myOfficeID,
       officeIDList: this.OfficeIDList
     }
    // return;
    this.loaderService.show();
    this.spinner=true;
    this.showTaskUpdateButton=false;  
     const result = await this.settingsService.updateTaskDetails(ReqModel).toPromise();
     if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.closeAssignedTask.emit(false);
      this.loaderService.hide();
      if(this.taskId==0){
        this.toastr.success("Attached to added successfully.", '', {
          timeOut: 3000,
        });
      }
      if(this.taskId>0){
        this.toastr.success("Attached to update successfully.", '', {
          timeOut: 3000,
        });
      }
     }
     else {
      this.spinner=false;
      this.loaderService.hide();
      this.closeAssignedTask.emit(false);    
     } 
   }


  close(){
    this.closeAssignedTask.emit(false)
  }


  // =========================================== Attached to ===========================================//


ShowAttchedToCore:boolean=false;
ShowAttchedToContact:boolean=false;
ShowAttchedToCompany:boolean=false;


attachedToCoreList:any=[]=[];
attachedToContactList:any=[]=[];
attachedToCompanyList:any=[]=[];


attachedToSelectedCore:any=[]=[];
attachedToSelectedContact:any=[]=[];
attachedToSelectedCompany:any=[]=[];

CorefolderID:number=0;
ContactfolderID:number=0;
CompanyfolderID:number=0;

roleIdList: any=[];

checkedAttachCore:boolean=false;
checkedAttachContact:boolean=false;
checkedAttachCompany:boolean=false;

selectCCC($event: MatRadioChange) {
  this.stateCtrl.reset();

  if ($event.value === 'Core') {
    this.ShowAttchedToCore=true;
    this.ShowAttchedToContact=false;
    this.ShowAttchedToCompany=false;

    this.checkedAttachCore=true;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=false;

    this.entityTypeAttached=1;   
  }
  if ($event.value === 'Contact') {
    this.ShowAttchedToCore=false;
    this.ShowAttchedToContact=true;
    this.ShowAttchedToCompany=false;
    
    this.checkedAttachCore=false;
    this.checkedAttachContact=true;
    this.checkedAttachCompany=false;

    this.entityTypeAttached=2;
  }
  if ($event.value === 'Company') {
    this.ShowAttchedToCore=false;
    this.ShowAttchedToContact=false;
    this.ShowAttchedToCompany=true;

    this.checkedAttachCore=false;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=true;

    this.entityTypeAttached=3;
    
  }
  
}



//======================Core============================//

searchCore(val) {
  if(val.length>=2){
    this.attachedToCoreList=[];
    if(val != ''){
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {      
     this.getsearchCore(val)
    }, 500);
  }else{
    this.attachedToCoreList=[];
  }
 } 
}

getsearchCore(searchValue: any) {
  var SelectedCCC=[];
  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
   if(SelectedCCC.length>0){
      this.CorefolderID = SelectedCCC[0].folderID;      
   }
   this.roleIdList=[];
   let roles=sessionStorage.getItem('roleIDList').split(',');
   roles.forEach(e => {      
   this.roleIdList.push(Number(e));
   });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CorefolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchCore(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCoreList = response.data;
         
      }else{
        this.attachedToCoreList=[];
      }
     }
   })
}


attchedToCoreSelected(coreSelected: any) {
  var checkCore=[];
  this.stateCtrl.setValue('');
  checkCore = this.attachedToSelectedCore.filter(x=> x.isDeleted==false);
  if(checkCore.length==0){   
    var shortName="";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');
       var ReqModel={
        taskAttachedEntityID:0,
        coreID: coreSelected.coreID,
        email: coreSelected.email,
        name: coreSelected.name,
        title: coreSelected.title,
        transactionID: coreSelected.transactionID,
        img: coreSelected.imageUrl,
        typeID: coreSelected.typeID,
        isDeleted: false,
        shortName: shortName,
       }
       this.attachedToSelectedCore.unshift( ReqModel);        
       this.stateCtrl.reset();
       if (this.attachedToSelectedCore.length > 0) {
        this.showTaskUpdateButton = true;
       }else {
        this.showTaskUpdateButton = false;
      }  }
    
}

attchedToRemoveCore(item:any) { 
  if(this.attachedToSelectedCore.length>0){
  this.attachedToSelectedCore.map(e => {   
    if (e.coreID == item.coreID) {
          e.isDeleted = true
      }
    return e;
  });
}
  
  
//  const index = this.attachedToSelectedCore.indexOf(item);
//  if (index >= 0) {
//     this.attachedToSelectedCore.find((x) => x.coreID == item.coreID).isDeleted = true;   
//    //this.attachedToSelectedCore.splice(index, 1);
//   }
  var checkCore=[];
  checkCore=this.attachedToSelectedCore.filter(x=> x.isDeleted == false);
  if(checkCore.length==0){
    this.stateCtrl.reset();
    this.showTaskUpdateButton = false;
  }else{
    this.stateCtrl.reset();
    this.showTaskUpdateButton = true;
  }
//  if(this.attachedToSelectedCore.length == 0){
//   this.stateCtrl.reset();
//   this.showTaskUpdateButton =false;
//  }
}




//======================Contact============================//

searchContacts(val) {
  if(val.length>=2){
    this.attachedToContactList=[];
    if(val != ''){
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {      
     this.getsearchContact(val)
    }, 500);
  }else{
    this.attachedToContactList=[];
  }
 } 
}

getsearchContact(searchValue: any) {
  var SelectedCCC=[];

  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
   if(SelectedCCC.length>0){
      this.ContactfolderID = SelectedCCC[0].folderID;      
   }
   this.roleIdList=[];
   let roles=sessionStorage.getItem('roleIDList').split(',');
   roles.forEach(e => {      
   this.roleIdList.push(Number(e));
   });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.ContactfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchContact(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToContactList = response.data;
         
      }else{
        this.attachedToContactList=[];
      }
     }
   })
}


attchedToContactSelected(contactSelected: any) {
  var checkContact=[];
  this.stateCtrl.setValue('');
  checkContact = this.attachedToSelectedContact.filter(x=> x.isDeleted==false);
  if(checkContact.length==0){   
    var shortName="";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
       var ReqModel={
        taskAttachedEntityID:0,
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        title: contactSelected.title,
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,
        typeID:contactSelected.typeID,
        isDeleted: false,
        shortName: shortName,
       }
       this.attachedToSelectedContact.unshift( ReqModel);        
       this.stateCtrl.reset();
       if (this.attachedToSelectedContact.length > 0) {
        this.showTaskUpdateButton = true;
       }else {
        this.showTaskUpdateButton = false;
      }  
  }    
}


attchedToRemoveContact(item:any) { 
  if(this.attachedToSelectedContact.length>0){
   this.attachedToSelectedContact.map(e => {   
    if (e.contactID == item.contactID) {
          e.isDeleted = true
      }
    return e;
  });
}
   
  var checkContact=[];
  checkContact=this.attachedToSelectedContact.filter(x=> x.isDeleted == false);
  if(checkContact.length==0){
    this.stateCtrl.reset();
    this.showTaskUpdateButton = false;
  }else{
    this.stateCtrl.reset();
    this.showTaskUpdateButton = true;
  }
}





//======================Company============================//

searchCompany(val) {
  if(val.length>=2){
    this.attachedToCompanyList=[];
    if(val != ''){
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {      
     this.getsearchCompany(val)
    }, 500);
  }else{
    this.attachedToCompanyList=[];
  }
 } 
}

getsearchCompany(searchValue: any) {
  var SelectedCCC=[];

  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
   if(SelectedCCC.length>0){
      this.CompanyfolderID = SelectedCCC[0].folderID;      
   }

   this.roleIdList=[];

   let roles=sessionStorage.getItem('roleIDList').split(',');
   roles.forEach(e => {      
   this.roleIdList.push(Number(e));
   });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CompanyfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchCompany(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCompanyList = response.data;
         
      }else{
        this.attachedToCompanyList=[];
      }
     }
   })
}



attchedToCompanySelected(companySelected: any) {
  var checkCompany=[];
  this.stateCtrl.setValue('');
  checkCompany = this.attachedToSelectedCompany.filter(x=> x.isDeleted==false);
  if(checkCompany.length==0){   
    var shortName="";
    shortName = companySelected.name.match(/\b(\w)/g).join('');
       var ReqModel={
        taskAttachedEntityID:0,
        companyID: companySelected.companyID,
        email: companySelected.email,
        name: companySelected.name,
        title: companySelected.title,
        transactionID: companySelected.transactionID,
        img: companySelected.imageUrl,
        typeID:companySelected.typeID,
        isDeleted: false,
        shortName: shortName,
       }
       this.attachedToSelectedCompany.unshift( ReqModel);        
       this.stateCtrl.reset();
       if (this.attachedToSelectedCompany.length > 0) {
        this.showTaskUpdateButton = true;
       }else {
        this.showTaskUpdateButton = false;
      }    
  }    
}

attchedToRemoveCompany(item:any) { 
  if(this.attachedToSelectedCompany.length>0){
  this.attachedToSelectedCompany.map(e => {   
    if (e.companyID == item.companyID) {
          e.isDeleted = true
      }
    return e;
  });
}   
  var checkCompany=[];
  checkCompany=this.attachedToSelectedCompany.filter(x=> x.isDeleted == false);
  if(checkCompany.length==0){
    this.stateCtrl.reset();
    this.showTaskUpdateButton = false;
  }else{
    this.stateCtrl.reset();
    this.showTaskUpdateButton = true;
  }
}


}
